/* eslint-disable @nx/enforce-module-boundaries */
import { Brandfolder, Collection, ResourceBase, ResourceType } from './entities';
import { CustomFieldValueOption } from '@integration-frontends/integration/core/model';

export type Container = Brandfolder | Collection;
export interface ContainerCustomField extends ResourceBase {
  type: ResourceType.CUSTOM_FIELD;
  containerId: string;
  searchable: boolean;
  prioritized: boolean;
  allowedValues: string[];
}

export type ContainerCustomFieldValue = CustomFieldValueOption;

export interface ContainerTag extends ResourceBase {
  type: ResourceType.TAG;
  containerId: string;
  searchable: boolean;
}

export interface ContainerFileTypeAggregates {
  containerId: string;
  name: string;
}

export const CONTAINER_REPO_TOKEN = 'CONTAINER_REPO';
export interface IContainerRepo {
  getContainer: (containerId: string) => Promise<Container>;
  getContainerCustomFields: (container: Container) => Promise<ContainerCustomField[]>;
  getContainerCustomFieldValues: (
    container: Container,
    customFieldKey: string,
  ) => Promise<ContainerCustomFieldValue[]>;
  getContainerTags: (container: Container) => Promise<ContainerTag[]>;
  getContainerFileTypeAggregates: (container: Container) => Promise<ContainerFileTypeAggregates[]>;
  getContainerFiletypeAggregations: (
    container: Container,
  ) => Promise<ContainerFileTypeAggregates[]>;
  getContainerTagAggregations: (container: Container) => Promise<ContainerTag[]>;
}
